import React, { useState } from 'react';
import { Redirect } from 'react-router'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

import Weight from '../ui/Weight.js';
//import Field from '../ui/Field.js';
import Box from '../ui/Box.js';
import ConfirmUI from '../ui/Confirm.js';
import ReceiptForm from './receiptinterface.js';
import api from '../../api/index.js';

import { callback } from '../../helpers.js';


export default (props) => {

	//const [interfaceOpen, setInterfaceOpen] = useState(false);
	const [redirect, setRedirect] = useState(false);

	const deleteClick = () => {
		confirmAlert({
			title: 'Permanently delete this harvest receipt: '  + props.HarvestReceiptID,
			customUI: ConfirmUI(
				()=>{props.onDelete(props.HarvestReceiptID)},
				<div><p className="red"><em><strong>This is not a safe action.</strong></em></p><p>Avoid this unless you've entered a harvest record by mistake. Are you sure you want to do this?</p></div>
			),
		});
	}


	const redirecttoedit = (e) => {
		setRedirect('/processors/' + props.ProcessorID + '/receipts/' + props.HarvestReceiptID);
	}

	const onSaved = (e) => {
		callback(props.refresh, [e]);
		//setInterfaceOpen(false);
	}


	if (redirect)
		return  <Redirect to={redirect} />


	return <Box className={"processor-receipt "} title={"Receipt #" + props.ReceiptNumber} options={[
		{
			label: <span><FontAwesomeIcon icon={faEdit} className="editIcon" /> Modify this processor receipt</span>,
			callback: redirecttoedit //()=>{setInterfaceOpen(true);}
		},
		{
			label: <span><FontAwesomeIcon icon={faExclamationTriangle} className="exclaimIcon" /> <small>Actually <strong>delete</strong> this processor receipt from the system</small></span>,
			callback: deleteClick
		},
	]}>
		<div className="inline-weight">{props.Date} / <Weight value={props.Weight} precision="0" /></div>
			{ props.records && 
				props.records.map((a, i) => {
					return <div className="record-small inline-weight" key={i}>
						<span className="date">{ a.Date }</span>
						<span className="invoice">{ a.InvoiceNumber }</span> <br />
						<Weight value={a.harvested} precision={0} />
						<span className="grade">{ a.GradeName }</span>
					</div>
				})
			}
	</Box>

}

/*
	<Box modal={true} isOpen={interfaceOpen} onRequestClose={(e)=>{setInterfaceOpen(false)}} title={"Processor Receipt " + props.ReceiptNumber + " interface"}>
			<ReceiptForm recordId={props.HarvestReceiptID} date={api.date(props.Date)} weight={props.Weight} processor={props.ProcessorID} rows={props.records} onSaved={onSaved}/>
		</Box>
*/